import { render } from "./GamePage.vue?vue&type=template&id=f3480238&scoped=true"
import script from "./GamePage.vue?vue&type=script&lang=js"
export * from "./GamePage.vue?vue&type=script&lang=js"

import "./GamePage.vue?vue&type=style&index=0&id=f3480238&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3480238"]])

export default __exports__